function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityShipmentIncoming = function SvgActivityShipmentIncoming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M-2401.689-3435.211h-7.646a.677.677 0 0 1-.665-.685v-12.89a.677.677 0 0 1 .665-.685h1.562v-.428a1.024 1.024 0 0 1 1-1.021h1.2a1.917 1.917 0 0 1 1.844-1.468 1.917 1.917 0 0 1 1.845 1.468h1.2a1.024 1.024 0 0 1 1 1.021v.428h1.561a.676.676 0 0 1 .665.685v5.351a5.965 5.965 0 0 0-.809.237v-5.44h-1.417v.229a1.024 1.024 0 0 1-1.005 1.022h-6.083a1.024 1.024 0 0 1-1.005-1.022v-.229h-1.417v12.593h7.215a6.017 6.017 0 0 0 .286.832zm-5.26-14.26v1.032a.22.22 0 0 0 .218.209h6.009a.221.221 0 0 0 .217-.209v-1.032h.016v-.428a.2.2 0 0 0-.2-.188h-1.416a.553.553 0 0 1-.546-.51 1.092 1.092 0 0 0-1.077-.958 1.105 1.105 0 0 0-1.076.958.552.552 0 0 1-.545.509h-1.418a.2.2 0 0 0-.2.188v.428zm4.862 10.9h-5.46a.412.412 0 0 1-.39-.43.412.412 0 0 1 .39-.43h5.672a5.964 5.964 0 0 0-.211.86zm1.447-3h-6.907a.412.412 0 0 1-.39-.43.412.412 0 0 1 .39-.431h7.691a.364.364 0 0 1 .136.027 6.028 6.028 0 0 0-.92.834zm.784-3h-7.691a.412.412 0 0 1-.39-.431.412.412 0 0 1 .39-.43h7.691a.412.412 0 0 1 .391.43.413.413 0 0 1-.391.428z",
    "data-name": "Subtraction 9",
    style: {
      strokeWidth: ".2px",
      fill: "#40ce66",
      stroke: "#40ce66"
    },
    transform: "translate(2412.171 3453.571)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5571",
    transform: "translate(0 -2.61)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    "data-name": "Ellipse 318",
    style: {
      fill: "#fff"
    },
    transform: "translate(10 12.61)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4057"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M700.929 776.28a4.93 4.93 0 1 0 3.477 1.445 4.923 4.923 0 0 0-3.477-1.445zm0 8.9a3.985 3.985 0 1 1 2.811-1.167 3.982 3.982 0 0 1-2.811 1.167z",
    "data-name": "Path 11720",
    style: {
      strokeWidth: ".3px",
      fill: "#40ce66",
      stroke: "#40ce66"
    },
    transform: "translate(-684.926 -762.593)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m811.269 902.575-2.161 2.217-1.079-1.079a.543.543 0 0 0-.749.749l1.468 1.468a.521.521 0 0 0 .749 0l2.547-2.621a.543.543 0 1 0-.779-.749z",
    "data-name": "Path 11721",
    style: {
      strokeWidth: ".3px",
      fill: "#40ce66",
      stroke: "#40ce66"
    },
    transform: "translate(-793.394 -885.485)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    "data-name": "Rectangle 4464",
    style: {
      fill: "none"
    }
  }));
};
export default SvgActivityShipmentIncoming;